import { Loader2 } from "lucide-react"

/** Dims one block until its next content is ready. Same chrome as the shell nav overlay. */
export function BlockPendingOverlay({ label }: { label: string }) {
  return (
    <div
      role="status"
      className="pointer-events-auto absolute inset-0 z-10 flex items-center justify-center bg-[var(--ui-overlay-light)]"
    >
      <Loader2 className="h-6 w-6 animate-spin text-ui-link" />
      <span className="sr-only">{label}</span>
    </div>
  )
}
